import React from 'react'
import { values, omit } from 'lodash'
import PropTypes from "prop-types"

import {
  Form, FormGroup, FormControl, ControlLabel, InputGroup, Checkbox,
  Panel, Modal
} from 'react-bootstrap'

import Button from '../../components/Button.jsx'
import MarkdownField from '../../lib/MarkdownField.jsx'
import FilesSelector from '../../lib/FilesSelector.jsx'
import { getText } from '../../lib/text.js'
import { randstr } from '../../../lib/Tools'

import Dish from './Dish'
import emptyDish from './emptyDish'

const styles = {
  fg: { display: "block", padding: 2 },
  label: { width: 200 },
  sublabel: { color: "#555", marginBottom: 2, fontSize: 14, fontStyle: "italic" },
}

class Menu extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = { open: false }
  }

  render() {
    const { menu, onChange, onRemove } = this.props

    return (
      <Panel style={{ position: 'relative' }}>
        <Panel.Body>
          <div style={{ display: 'inline', width: '100%' }}>
            <span style={{ fontSize: 24 }}>📖 </span>

            <span style={{ fontSize: "1.2em", color: menu.hidden ? "grey" : "black", marginLeft: 10 }}>
              {menu.name || getText("Sin nombre")}
            </span>

            <Checkbox
              checked={menu.hidden}
              onChange={evt => onChange({ hidden: evt.target.checked })}
              style={{ marginRight: 50, float: "right", display: "inline" }}
            >
              Oculto
            </Checkbox>

            <Button
              onClick={() => this.setState({ open: true })}
              style={{ position: 'absolute', right : 10 }}
              glyph="pencil"
            />
          </div>

          {
            this.state.open && (
              <Modal show onHide={() => this.props.onChange()}>
                <Modal.Header>
                  <Modal.Title>Menú: {menu.name}</Modal.Title>
                </Modal.Header>
                <Modal.Body>

                  <Form inline>
                    <FormGroup style={styles.fg}>
                      <ControlLabel style={styles.label}>{getText("Nombre")}: </ControlLabel>
                      <FormControl
                        className= "name-control"
                        type="text"
                        value={menu.name}
                        onChange={evt => onChange({ name: evt.target.value })}
                      />
                    </FormGroup>
                    <FormGroup style={styles.fg}>
                      <ControlLabel style={styles.label}>{getText("Nombre en chino")}: </ControlLabel>
                      <FormControl
                        className= "chname-control"
                        type="text"
                        value={menu.chName}
                        onChange={evt => onChange({ chName: evt.target.value })}
                      />
                    </FormGroup>
                    <FormGroup style={styles.fg}>
                      <ControlLabel style={styles.label}>{getText("Precio")}: </ControlLabel>
                      <InputGroup>
                        <FormControl
                          className= "price-control"
                          type="number"
                          value={menu.price}
                          onChange={evt => this.props.onChange({ price: evt.target.value })}
                        />
                        <InputGroup.Addon>€</InputGroup.Addon>
                      </InputGroup>
                    </FormGroup>
                    <FormGroup style={styles.fg}>
                      <MarkdownField
                        value={menu.description}
                        label={getText("Descripción menú (cortita)")}
                        onChange={description => this.props.onChange({ description })}
                      />
                    </FormGroup>
                    <FormGroup style={styles.fg}>
                      <MarkdownField
                        value={menu.drinksDescription}
                        label={getText("Descripción bebidas (cortita)")}
                        onChange={drinksDescription => this.props.onChange({ drinksDescription })}
                      />
                    </FormGroup>
                    <FormGroup style={styles.fg}>
                      <Checkbox
                        style={{ marginTop: 10 }}
                        checked={menu.includesMeat}
                        onChange={evt => this.props.onChange({ includesMeat: evt.target.checked })}
                      >
                        <span style={{ marginLeft: '5px', fontWeight: "bold" }}>{getText("Incluye carne")}</span>
                      </Checkbox>
                      <Checkbox
                        style={{ marginLeft: 10, marginTop: 10 }}
                        checked={menu.includesFish}
                        onChange={evt => this.props.onChange({ includesFish: evt.target.checked })}
                      >
                        <span style={{ marginLeft: '5px', fontWeight: "bold" }}>{getText("Incluye pescado")}</span>
                      </Checkbox>
                      <Checkbox
                        style={{ marginLeft: 10, marginTop: 10 }}
                        checked={menu.isVegan}
                        onChange={evt => this.props.onChange({ isVegan: evt.target.checked })}
                      >
                        <span style={{ marginLeft: '5px', fontWeight: "bold" }}>{getText("Es vegetariano")}</span>
                      </Checkbox>
                    </FormGroup>
                    <FilesSelector
                      includeNotes
                      value={menu.background}
                      fileNotes={menu.fileNotes}
                      onChange={background =>     { console.log(JSON.stringify({ background })); onChange({ background }); }}
                      onNotesChange={fileNotes => { console.log(JSON.stringify({ fileNotes  })); onChange({ fileNotes });  }}
                      labels={{
                        image: getText("Imágen")
                      }}
                      extensions={{ image: ["jpg", "jpeg", "png"] }}
                      title = {getText("Imagen menú")}
                    />
                    <Panel style={{ backgroundColor: "rgba(159,234,215,0.1)" }}>
                      <Panel.Heading>
                        <h3>{getText("Platos")}</h3>
                      </Panel.Heading>
                      <Panel.Body>
                        <div>
                          {
                            values(menu.dishes).map(dish => (
                              <Dish
                                key={dish.id}
                                dish={dish}
                                withoutPrice
                                onChange={change => onChange({
                                  dishes: {
                                    ...menu.dishes,
                                    [dish.id]: { ...menu.dishes[dish.id], ...change }
                                  }
                                })}
                                onRemove={() => onChange({ dishes: omit(menu.dishes, dish.id) })}
                              />
                            ))
                          }
                          <Button
                            glyph={'plus'}
                            onClick={() => {
                              const id = randstr(12)
                              onChange({ dishes: { ...menu.dishes, [id]: { ...emptyDish, id } } })
                            }}
                          >
                            Añadir plato
                          </Button>
                        </div>
                      </Panel.Body>
                    </Panel>
                    <Button glyph="minus" bsStyle="link" onClick={() => onRemove()}>
                      Eliminar menú
                    </Button>
                  </Form>

                </Modal.Body>
                <Modal.Footer>
                  <Button onClick={() => this.setState({ open: false })}>Cerrar</Button>
                </Modal.Footer>
              </Modal>
            )
          }
        </Panel.Body>
      </Panel>
    )
  }
}

Menu.propTypes = {
  onChange: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired,
  menu: PropTypes.object.isRequired,
}

export default Menu
